import axiosClient from 'apis/setup/axiosClient';
import axiosGraphQL from './GraphQL/axiosGraphQL';
import {
  GET_COUNTER_TERRORISM_RECORDS_QUERY,
  GET_COUNTER_TERRORISM_FAFT_QUERY,
  GET_COUNTER_TERRORISM_PEPS_QUERY,
} from './GraphQL/Queries/terroristQuery';
import {
  GET_TERRORIST_VERIFICATION_LIST,
  UPDATE_CUSTOMER_TERRORISM,
} from './GraphQL/Queries/terroristVerificationQuery';
import {
  COUNTER_TERRORISM_RECORDS_VARIABLES,
  COUNTER_TERRORISM_FAFT_VARIABLES,
  COUNTER_TERRORISM_PEPS_VARIABLES,
  IGetCounterTerrorismRecordsParams,
  IGetCounterTerrorismFaftParams,
  IGetCounterTerrorismPepsParams,
} from './GraphQL/Variables/terrorist';
import {
  TERRORIST_VERIFICATION_VARIABLES,
  IGetTerroristVerificationParams,
} from './GraphQL/Variables/terroristVerification';

export const TerroristApis = {
  getRecords: async (params: IGetCounterTerrorismRecordsParams) => {
    return await axiosGraphQL.post('/graphql', {
      query: GET_COUNTER_TERRORISM_RECORDS_QUERY,
      variables: COUNTER_TERRORISM_RECORDS_VARIABLES.getAll(params),
    });
  },
  getFaft: async (params: IGetCounterTerrorismFaftParams) => {
    return await axiosGraphQL.post('/graphql', {
      query: GET_COUNTER_TERRORISM_FAFT_QUERY,
      variables: COUNTER_TERRORISM_FAFT_VARIABLES.getAll(params),
    });
  },
  getPeps: async (params: IGetCounterTerrorismPepsParams) => {
    return await axiosGraphQL.post('/graphql', {
      query: GET_COUNTER_TERRORISM_PEPS_QUERY,
      variables: COUNTER_TERRORISM_PEPS_VARIABLES.getAll(params),
    });
  },
  importRecords: async (file: File, userId?: string) => {
    const formData = new FormData();
    formData.append('file', file);
    return await axiosClient.post(
      `/aml/import-records${userId ? `?userId=${userId}` : ''}`,
      formData,
      {
        headers: { 'Content-Type': 'multipart/form-data' },
      },
    );
  },
  importFaft: async (file: File, userId?: string) => {
    const formData = new FormData();
    formData.append('file', file);
    return await axiosClient.post(
      `/aml/import-faft${userId ? `?userId=${userId}` : ''}`,
      formData,
      {
        headers: { 'Content-Type': 'multipart/form-data' },
      },
    );
  },
  importPeps: async (file: File, userId?: string) => {
    const formData = new FormData();
    formData.append('file', file);
    return await axiosClient.post(
      `/aml/import-peps${userId ? `?userId=${userId}` : ''}`,
      formData,
      {
        headers: { 'Content-Type': 'multipart/form-data' },
      },
    );
  },
  getVerificationList: async (params: IGetTerroristVerificationParams) => {
    return await axiosGraphQL.post('/graphql', {
      query: GET_TERRORIST_VERIFICATION_LIST,
      variables: TERRORIST_VERIFICATION_VARIABLES.getList(params),
    });
  },
  updateCustomerTerrorism: async (input: any) => {
    return await axiosGraphQL.post('/graphql', {
      query: UPDATE_CUSTOMER_TERRORISM,
      variables: { input },
    });
  },
  triggerScan: async (userId?: string) => {
    return await axiosClient.post(
      `/aml/trigger-scan${userId ? `?userId=${userId}` : ''}`,
    );
  },
};
